import Action from '../../Action'
// import './styles/ModalDeleteUSer.css'
import { useState } from 'react';
import LoadSimple from '../../LoadSimple';
import { capitalizeFirstLetter } from '../../../utils/utils';
// import './Maintenance-styles/ModalAddHost.css'
import { lang } from '../../generales/traduction';
import Search from '../../generales/Search';
import Paginador from '../../generales/Paginador';
const ModalAddHost =({languaje,handleRemoveItem,mode,hosts,elementsList,SetElementList,setDataWorkFlow,dataWorkFlow,closeAddHostModal})=>{
  const [poolRows,setPoolRows]=useState([])
    const [allSelected, setAllSelected] = useState(false);
    const [hostSelected,setHostSelected]=useState(hosts.filter(item => poolRows.includes(item.hostid)))
    const [contRowsSelected,setContRowSelected]=useState(0)
    const [searchResults, setSearchResults] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [limitList, setLimitList] = useState(50); 
  const [pageActual, setPageActual] = useState(1);
  const [searchResult, setSearchResult] = useState(null);
    var dataList = searchTerm === "" ? hosts : searchResults;
    const startLimit = limitList * pageActual - limitList;
    const pages = parseInt(dataList.length / limitList) + 1;
    const handleSelectAll = () => {
        if (allSelected) {
          // Si ya está todo seleccionado, deselecciona todo
          setPoolRows([]);
        } else {
          setPoolRows(hosts.map(item => item.hostid))
        }
        setAllSelected(!allSelected); // Alterna el estado de seleccionar todo
      };
      const handleSearch = (query) => {
        setSearchResult(`Resultados para: ${query}`);
      };
      const handleSelectChange = (e) => {
        setPageActual(1)
        setLimitList(e.target.value);setPageActual(1);
      };
      /************************************************* */
      /************************************************* */
      /************************************************* */
      /*******************seleccionar host ************* */
      /************************************************* */
      /************************************************* */
      /************************************************* */

      const rowSelected = (elemento) => {
        setDataWorkFlow((prevState)=>{
          return {
              ...prevState,
            ['hostid']:parseInt(elemento.hostid)
          }
          
      })
        SetElementList((prevState)=>{
          return {
              ...prevState,
            ['host']:elemento.host
          }
          
      })
      };
      const cancelItem=()=>{
        setDataWorkFlow((prevState)=>{
          return {
              ...prevState,
            ['hostid']:0
          }
          
      })
      SetElementList((prevState)=>{
        return {
            ...prevState,
          ['host']:""
        }
        
    })
    handleRemoveItem({ id: 'host', label: capitalizeFirstLetter(lang[languaje]['dispositivo']), type: 'entity' })
        closeAddHostModal()
      }
    return(
        <>
        <div className="modal-GS-content">
        <div className='card-modal-gs modal-verificate'>
                <div className='head-card-modal-gs'>
                    <div className='title-head-card-modal-gs'>
                    {lang[languaje]['agregar'].toUpperCase()+" "+lang[languaje]['dispositivos'].toUpperCase()}
                    </div>
                </div>
                <div className='content-card-modal-gs' style={{overflowY: 'scroll',scrollbarWidth: 'thin',display:'block'}}>
                    <div className='half-content-card-modal-gs' style={{width:'100%',height:'90%'}}>
                    <>
   <div className='head-cis'>
    <div className='title-cis'>
                <Search
                    searchResults={searchResults}
                    setSearchResults={setSearchResults}
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                    onSearch={handleSearch}
                    dataObject={hosts}
                    searchResult={searchResult}
                    setSearchResult={setSearchResult}
                    languaje={languaje}
                  />
          <div className={"cont-result-registers"+mode} style={{width:'25%',bottom:'0px'}}>
         
                  <p style={{  textAlign: "center" ,fontSize:'var(--font-size-xSmall)'}}>
                    &nbsp;
                    {capitalizeFirstLetter(lang[languaje]['resultadosEncontrados'])+" (" +
                      dataList.length +
                      ") " 
                      }
                  </p> 
          </div>
         
               
             
                </div>
                
            </div>
            <div className='cont-cis'>
            <>
      <div className="main-panel-cis">
      <div className="compact-content-portafolio">
      <div className={"content-portafolio-head"+mode}>
                      <div style={{fontSize:'var(--font-size-xSmall',width:'100%',height:'100%',display:'flex',justifyContent:'center',alignItems:'center',color:'var(--txt-color)'}}>
                        Dispositivo seleccionado :{elementsList.host}
                      </div>
              </div>
        <div className="content-portafolio">
          <div className="cont-portafolio-table">
            <div className="content-card-portafolio" id="content">
             
            <div className="cont-table-portafolio">
      <div className={"head-table-portafolio"+mode}>
      <div className="compact-head-table-portafolio">
      {/* <div className="field-head-table-mantenimiento field-medium">  <div className='cont-checkbox'>
                 <input type='checkbox' className='NotifiCheckBox ' checked={allSelected} style={{height:'15px'}} onChange={()=>console.log("all")}  onClick={()=>handleSelectAll()} ></input>
                </div></div> */}
        {/* <div className="field-head-table-mantenimiento field-small"> ID</div> */}
        <div className="field-head-table-mantenimiento field-larger" style={{width:'80%'}} >{capitalizeFirstLetter(lang[languaje]['nombre'])} </div>
        <div className="field-head-table-mantenimiento field-medium" style={{width:'15%'}}>{'IP'}</div>
       
        </div>
      </div>
      <div className="body-table-portafolio">
       
      <>
      <div className="cont-row-user-list">
        {(
          dataList
            .slice(startLimit, parseInt(pageActual) * parseInt(limitList))
            .map((elemento, indice) => (
              <div
                className={" row-table-portafolio"+mode+" "+(elemento.hostid==dataWorkFlow.hostid?'hostFlowSelected':'') }
                key={indice}
                onClick={()=>rowSelected(elemento)}
              >
                 <div className="field-body-table-mantenimiento field-medium">
                 {/* <div className='cont-checkbox'>
                 <input type='checkbox' checked={poolRows.some((row) => row === elemento.hostid)} className='NotifiCheckBox ' style={{height:'15px'}}   onChange={()=>rowSelected(elemento)} ></input>
                </div> */}
                </div>
                {/* <div className="field-body-table-mantenimiento field-small">
                  {elemento.hostid}
                </div> */}
                <div className="field-body-table-mantenimiento field-larger" style={{width:'80%'}}>
                  {elemento.name}
                </div>
                <div className="field-body-table-mantenimiento field-medium" style={{width:'15%'}}>
                  {elemento.agent_ip}
                </div>
               
                
                
               
              </div>
            ))
        )}
        { (dataList.length == 0 ) ? (
          <div className="no-results">{capitalizeFirstLetter(lang[languaje]['sinResultados'])}.</div>
        ) : (
          ""
        )}
      </div>
      
    </>
      </div>
    </div>
            </div>
          </div>

          </div>
          <div className={"content-portafolio-footer"+mode}>
          <div className="cont-display-paginador" style={{position: 'absolute',left: '0%',justifyContent: 'start'}}>
            
            {/* <div className={"cont-half-display-paginador"+mode}>
            <p style={{  textAlign: "center" }}>
                            &nbsp;
                            {(contRowsSelected!=0)?"("+contRowsSelected+")  "+capitalizeFirstLetter(lang[languaje]['registosSeleccionados']):''}
                      </p> 
                  
            </div> */}
          </div>  
          <div className="cont-display-paginador" style={{width:'60%'}}>
                    <Paginador  pages={pages}
                                pageActual={pageActual}
                                setPageActual={setPageActual}
                                mode={mode}></Paginador>
          </div>
          <div className="cont-display-paginador" style={{width:'50%'}}>
            <div className={"cont-half-display-paginador"+mode}>
                      
            <div>
      <label htmlFor="selector">{capitalizeFirstLetter(lang[languaje]['filasPagina'])}: </label>
      <select id="selector" value={limitList} className="pageSelector" onChange={handleSelectChange}>
        <option value={10}>10</option>
        <option value={50} >50</option>
        <option value={100}>100</option>
        <option value={500}>500</option>
        <option value={1000}>1000</option>
      </select>

      
    </div>
            </div>
            <div className={"cont-half-display-paginador"+mode} >
            <p style={{  textAlign: "center" ,fontSize:'var(--font-size-xSmall) !important'}}>
                            &nbsp;
                            {"(" +
                        (startLimit + 1) +
                        " - " +
                        (dataList.length >  parseInt(pageActual ) * parseInt(limitList)
                          ?  parseInt(pageActual ) * parseInt(limitList)
                          : dataList.length) +
                        ")  "+lang[languaje]['de']+" " +
                        dataList.length +
                        " "+lang[languaje]['resultados']}
                      </p>
                  
            </div>
          </div>  
                    
        </div>
        </div>
      </div>
      
    </>
                
            </div>
   </>
      
                    </div>
                    <div className='contentButtomsWorkflow'>
                    <div className="form-GS-box"> 
                    <div className="user-box-GS" style={{height:'100%'}}>
                                        {
                                            (false)?<LoadSimple></LoadSimple>
                                            :
                                            <>
                                            <Action disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(lang[languaje]['cancelar'])}  action={()=>{cancelItem()}}/>
                                            <Action disabled={(elementsList.host_name=="")?true:false} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['guardar'])}  action={closeAddHostModal}/>
                                            </>
                                            // <Action disabled={disabled} origen='Login' titulo='Guardar'  action={Registrar}/>
                                        }
                                            
                                    {
                                        // (registerIsValid && data.message!=="User deleted successfully")?<span className='form-msg-ok'>Usuario registrado correctamente</span>:''
                                    }
                                        
                                    </div>
                                    </div>
                    </div>
                    {/* <div className='half-content-card-modal-gs'>
                    <>
                <div className='head-cis'>
                <div className="cont-buttons-panel" style={{width:'50%'}}>
                  
                  <Action
                  disabled={false}
                  origen="Azul"
                  titulo={""+capitalizeFirstLetter(lang[languaje]['Aceptar'])}
                  action={closeAddHostModal}
                />
                  
                    
                  
                 
                </div>
                
                </div>
            <div className='cont-cis'>
            <>
      <div className="main-panel-cis">
      <div className="compact-content-portafolio">
      <div className={"content-portafolio-head"+mode} style={{background:'var(--third-color)',color:'var(--white-color)'}}>
                <div className='title-host-added'>{capitalizeFirstLetter(lang[languaje]['hostSelected'])}</div>
              </div>
        <div className="content-portafolio">
          <div className="cont-portafolio-table">
            <div className="content-card-portafolio" id="content">
             
            <div className="cont-table-portafolio">
      
      <div className="body-table-portafolio">
       
      <>
      <div className="cont-row-user-list">
        
        {(
          hostSelected
            .map((elemento, indice) => (
                <div className='content-row-host-selected' key={indice}>
                <div className='row-host-selected'>
                    <div className='text-host-selected'>
                    {elemento.host}
                    </div>
                    <div className='delete-host-selected' onClick={(()=>rowSelected(elemento))}>
                                    X
                    </div>
                </div>              
            </div>
            ))
        )}
        { (dataList.length == 0 ) ? (
          <div className="no-results">{capitalizeFirstLetter(lang[languaje]['sinResultados'])}.</div>
        ) : (
          ""
        )}
      </div>
      
    </>
      </div>
    </div>
            </div>
          </div>

          </div>
          <div className={"content-portafolio-footer"+mode} style={{justifyContent:'center'}}>
          <div className="cont-display-paginador" style={{position: 'absolute',justifyContent: 'center',width:'50%'}}>
            
            <div className={"cont-half-display-paginador"+mode}>
            <p style={{  textAlign: "center" }}>
                            &nbsp;
                            {"("+hostSelected.length+")  "+capitalizeFirstLetter(lang[languaje]['registosSeleccionados'])}
                      </p> 
                  
            </div>
          </div>  
          
           
                    
        </div>
        </div>
      </div>
      
    </>
                
            </div>
   </>
                    </div> */}
                </div>
            </div>
            </div>
        </>
    )
}

export default ModalAddHost